import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    minWidth: idsTokens.accordion.default.spacing.standard.expanded.body.min.width,
    minHeight: idsTokens.accordion.default.spacing.standard.expanded.body.min.height,
    paddingTop: idsTokens.accordion.default.spacing.standard.expanded.body.padding.top,
    paddingBottom: idsTokens.accordion.default.spacing.standard.expanded.body.padding.bottom,
    paddingLeft: idsTokens.accordion.default.spacing.standard.expanded.body.padding.left,
    paddingRight: idsTokens.accordion.default.spacing.standard.expanded.body.padding.right,
    gap: idsTokens.accordion.default.spacing.standard.expanded.body.padding.gap,
    color: idsTokens.accordion.default.color.body.text.enabled,
    backgroundColor: idsTokens.accordion.default.color.body.background.enabled,
    fontSize: idsTokens.typography.font.size.base,
    lineHeight: idsTokens.typography.lineHeight.base,
    letterSpacing: idsTokens.typography.spacing.letter.lg,
    fontWeight: idsTokens.typography.font.weight.regular,
    boxSizing: 'border-box',
    borderRadius: idsTokens.accordion.default.radius.body,
    display: 'flex',
    flexDirection: 'column',
  },
});
